import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import MyStethiApplicationForm from 'pages/Applications/MyStethiApplicationForm'
import { fetchCreateJobApplication, fetchUpdateJobApplication } from 'src/redux/application'
import { useApplicationDrawer } from '../Applications/useApplicationDrawer'
import { useApplications } from '../Applications/useApplications'
import { fetchAllApplications } from 'src/redux/application'

const ApplicationDrawer = ({ open, onClose, job, jobs }) => {
  const { applications = [] } = useSelector(state => state.application)
  const [applicationData, setApplicationData] = React.useState({})
  const { formState, handleInputChange, setFormState, userId, candidateId, jobs: hookJobs } = useApplicationDrawer({
    selectedRow: applicationData,
    open,
  })

  const { statuses, availableTags } = useApplications()
  const isNew = job.candidateJobApplicationId == null
  const title = 'Track Job'
  const dispatch = useDispatch()

  const currentJobEntry = {
    id: job.id,
    title: job.title,
    employerName: job.employerName || job.employer?.name,
  }
  const baseJobs = jobs.length > 0 ? jobs : hookJobs
  const effectiveJobs = baseJobs.some(j => j.id === job.id)
    ? baseJobs
    : [currentJobEntry, ...baseJobs]

  React.useEffect(() => {
    if (open === true) {
      dispatch(fetchAllApplications({ candidateId, jobId: job.id }))
    }
  }, [open])

  React.useEffect(() => {
    if (open) {
      if (applications.length === 1) {
        setApplicationData({
          ...applications[0],
        })
      } else {
        setApplicationData({
          jobId: job.id,
          jobName: job.title,
          hospital: job.employerName || job.employer?.name,
        })
      }
    }
  }, [applications, job, open])
  const handleSave = () => {
    if (isNew) {
      dispatch(
        fetchCreateJobApplication({ ...formState, candidateId: candidateId, userId: userId }),
      )
    } else {
      dispatch(
        fetchUpdateJobApplication({ ...formState, candidateId: candidateId, userId: userId }),
      )
    }
    onClose()
  }

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant='h6'>{title}</Typography>
        <IconButton onClick={onClose} sx={{ width: 'fit-content' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {formState && (
          <MyStethiApplicationForm
            handleInputChange={handleInputChange}
            formState={formState}
            statuses={statuses}
            availableTags={availableTags}
            isNew={isNew}
            setFormState={setFormState}
            handleSave={handleSave}
            onClose={onClose}
            jobs={effectiveJobs}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default ApplicationDrawer
